require('./myProfileEditShippingAddressStep2.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const trim = require('lodash/string/trim');

// @commons
const { formatText, FormattedText } = require('core/i18n').i18n;

// @components
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const Highlighted = require('components/commons/highlighted/highlighted');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @constants
const { getTranslatedRoad } = require('constants/typeOfRoads');
const PROVINCES = require('constants/provinces');
const { getTranslatedCountry } = require('constants/countries');
const {
    ADD_NEW_SHIPPING_ADDRESS,
    SHIPPING_ADDRESS_EDIT,
} = require('constants/operationTypes');

// @utilities
const { conditionalClassName } = require('utilities/conditionals/conditionalClassname');

// @helpers
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');

class MyProfileEditShippingAddressStep2 extends React.Component {

    highlightComponentWrapper(status, value) {
        return (
            <Highlighted
                isHighlighted={status}
            >
                {value}
            </Highlighted>
        );
    }

    isDirty(immHireContactData, field) {
        const initialValue = immHireContactData.getIn([`${field}Initial`, 'value']);

        return !!immHireContactData.get(field) &&
            initialValue !== undefined &&
            trim(initialValue) !== trim(immHireContactData.getIn([field, 'value']));
    }

    buildHighlightedModificationsMessage(){
        const {
            immProfileShippingAddress,
            isShowOnly,
        } = this.props;

        let message;
        let subtitle;

        if (__CONTACT_CENTER__) {
            if (isShowOnly) {
                subtitle = formatText('cc_profileEditShippingAddress-profileEditShippingAddress_operationConfirmation');
            } else if (!isPrintOfficeMode()) {
                if (immProfileShippingAddress.get('hasShippingAddress')) {
                    subtitle = formatText('cc_profileEditShippingAddress-profileEditShippingAddress_editShippingAlert');
                } else {
                    subtitle = formatText('profileEditShippingAddress-profileEditShippingAddress_addInfoMessage01');
                }
            }
        } else {
            if (immProfileShippingAddress.get('hasShippingAddress')) {
                message = this.highlightComponentWrapper(true, <FormattedText value="profileEditShippingAddress-profileEditShippingAddress_infoMessage02"/>);
                subtitle = formatText('profileEditShippingAddress-profileEditShippingAddress_editInfoMessage01');
            } else {
                subtitle = formatText('profileEditShippingAddress-profileEditShippingAddress_addInfoMessage01');
            }
        }

        return (
            <p className="profile-edit-shipping-address-step-2__subtitle">
                {subtitle}
                {message}
            </p>
        );
    }

    formatAddress(immHireContactData) {
        const roadType = immHireContactData.getIn(['roadType', 'value']);
        const roadName = immHireContactData.getIn(['roadName', 'value']);
        const number = immHireContactData.getIn(['number', 'value']);
        const others = immHireContactData.getIn(['others', 'value']);
        const population = immHireContactData.getIn(['population', 'value']);
        const province = immHireContactData.getIn(['province', 'value']);
        const country = immHireContactData.getIn(['country', 'value']);
        const postalCode = immHireContactData.getIn(['postalCode', 'value']);
        const fields = [
            {
                dirty: this.isDirty(immHireContactData, 'roadType'),
                value: !!roadType ? getTranslatedRoad(roadType) : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'roadName'),
                value: !!roadName ? roadName : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'number'),
                value: (!!number ? number : '') + ',',
            },
            {
                dirty: this.isDirty(immHireContactData, 'others'),
                value: !!others ? (others + ',') : '',
            },
            {
                 dirty: this.isDirty(immHireContactData, 'population'),
                 value: !!population ? (population + ',') : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'province'),
                value: !!province ? (PROVINCES[province] + ',') : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'country'),
                value: !!country ? getTranslatedCountry(country) : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'postalCode'),
                value: !!postalCode ? `(${postalCode})` : '',
            }
        ];
        const addressFields = fields.map((field, index) => {
            const space = !!index ? ' ' : '';
            const highlightedField = this.highlightComponentWrapper(field.dirty, field.value);

            return (
                <span key={index}>
                    {space}
                    {highlightedField}
                </span>
            );
        });

        return <div className="profile-edit-shipping-address-step-2__address">{addressFields}</ div>;
    }

    getCcOfficeModeDisclaimers() {
        const {
            immProfileFields,
            immProfileShippingAddress,
        } = this.props;

        let retObj = {};

        if (__CONTACT_CENTER__ && isPrintOfficeMode()) {
            const fullName = PersonalDataHelper.getFullName(immProfileFields, false);

            let firstDisclaimerMessage = 'cc_profileEditShippingAddress-profileEditShippingAddress_newShippingAlert';

            if (immProfileShippingAddress.get('hasShippingAddress')) {
                firstDisclaimerMessage = 'cc_profileEditShippingAddress-profileEditShippingAddress_editShippingAlert';
            }

            retObj.ccOfficeModeDisclaimer1 = (
                <BlockInfo extraClass="show-data__block-info">
                    <p><FormattedText value="cc_profileEditShippingAddress-profileEditShippingAddress_srOrSra" /> <b>{fullName}</b></p>
                    <p><FormattedText value={firstDisclaimerMessage} /></p>
                </BlockInfo>
            );

            retObj.ccOfficeModeDisclaimer2 = (
                <BlockInfo extraClass="show-data__block-info">
                    <p><FormattedText value="cc_profileEditShippingAddress-profileEditShippingAddress_editShippingConformity" /> <b>{fullName}</b></p>
                </BlockInfo>
            );
        }

        return retObj;
    }

    buildReadOnly() {
        return  (
            <div className="verify-otp-step__security-pattern-message-column">
                <p className="verify-otp-step__security-pattern-message-block">
                    <FormattedText
                        className="verify-otp-step__security-pattern-message"
                        value="verifyOtpStep-securityPatternMessage"
                    />
                </p>
            </div>
        );
    }

    buildSecurityPattern() {
        const { immProfileShippingAddress } = this.props;

        let operationType = ADD_NEW_SHIPPING_ADDRESS;

        if (immProfileShippingAddress.get('hasShippingAddress')) {
            operationType = SHIPPING_ADDRESS_EDIT;
        }

        return  (
            <SignaturePattern
                isInVerticalWizard={__CONTACT_CENTER__}
                operationType={operationType}
                operationParams={{}}
            />
        );
    }

    render() {
        const {
            immHireContactData,
            immProfileShippingAddress,
            isShowOnly,
        } = this.props;

        const confirmationMessage = this.buildHighlightedModificationsMessage();
        const addressLabel = this.formatAddress(immHireContactData);
        const officeModeDisclaimers = this.getCcOfficeModeDisclaimers();
        const titleClass = conditionalClassName('', 'profile-edit-shipping-address-step-2__title--cc', 'profile-edit-shipping-address-step-2__title');

        let subtitle = 'profileEditShippingAddress-profileEditShippingAddress_newShippingAddress';
        let body;
        let otpComponent;

        if (immProfileShippingAddress.get('hasShippingAddress')) {
            subtitle = 'profileEditShippingAddress-profileEditShippingAddress_shippingAddress';
        }

        if (isShowOnly) {
            otpComponent = this.buildReadOnly();
        } else {
            otpComponent = this.buildSecurityPattern();
            body = (
                <React.Fragment>
                    {officeModeDisclaimers.ccOfficeModeDisclaimer1}
                    <OKInformativeList columns={2}>
                        <OKInformativeListItem
                            title={formatText(subtitle)}
                        >
                            {addressLabel}
                        </OKInformativeListItem>
                    </OKInformativeList>
                    {officeModeDisclaimers.ccOfficeModeDisclaimer2}
                </React.Fragment>
            );
        }

        return (
            <article className="profile-edit-shipping-address-step-2">
                <FormattedText
                    className={titleClass}
                    value="profileEditShippingAddress-profileEditShippingAddress_confirmationTitle"
                />
                {confirmationMessage}
                {body}
                {otpComponent}
            </article>
        );
    }
}

MyProfileEditShippingAddressStep2.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immProfileFields: PropTypes.object.isRequired,
    immProfileShippingAddress: PropTypes.object.isRequired,
    isShowOnly: PropTypes.bool,
};

MyProfileEditShippingAddressStep2.defaultProps = {
    isShowOnly: false,
}

module.exports = MyProfileEditShippingAddressStep2;
